import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgViewOff2 = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.058 7.403a.675.675 0 0 1 .914.275 7.3 7.3 0 0 0 1.356 1.78 1 1 0 0 1 .089.085c1.416 1.323 3.389 2.15 5.584 2.15 2.19 0 4.16-.824 5.576-2.143a.7.7 0 0 1 .103-.097 7.3 7.3 0 0 0 1.35-1.775.675.675 0 0 1 1.188.64 8.5 8.5 0 0 1-1.136 1.622l2.664 2.232a.675.675 0 0 1-.867 1.034l-2.774-2.323a9.3 9.3 0 0 1-2.944 1.641l1.282 3.23a.675.675 0 1 1-1.255.497l-1.342-3.38a9.9 9.9 0 0 1-3.697-.001l-1.342 3.381a.675.675 0 1 1-1.255-.498l1.283-3.23a9.3 9.3 0 0 1-2.94-1.641l-2.773 2.325a.675.675 0 1 1-.867-1.035l2.664-2.233a8.5 8.5 0 0 1-1.136-1.621.675.675 0 0 1 .275-.915"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgViewOff2;
